import { createSlice } from "@reduxjs/toolkit";
import { query } from "../../services/object";

export const memoryGameSlice = createSlice({
    // Slice name, this should be always as page name.
    name: "memoryGame",

    // Initial state for the slice
    initialState: {
        data: {},
        status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = "succeeded";
            state.error = null;
        },
        error: (state, action) => {
            state.status = "failed";
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? "loading" : "succeeded";
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? "initalLoading" : "succeeded";
        },
    },
});

export default memoryGameSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading } = memoryGameSlice.actions;

// Public Selectors
export const selectMemoryGameData = (state) => state.memoryGame.data;
export const selectMemoryGameStatus = (state) => state.memoryGame.status;
export const selectMemoryGameError = (state) => state.memoryGame.error;

export const initializeAsync = (props) => async (dispatch) => {
    dispatch(initialLoading(true));

    let arts = await query("memoryGame", "getAllRecords");
    if (arts.isSuccess) {
        dispatch(initialize({ records: arts.data }));
    }
};
